import * as actionTypes from './actionTypes';
import { getSeparatedCurrentAndAllById } from './utils';

const initialState = {
  token: null,
  notifications: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NEW_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case actionTypes.NEW_NOTIFICATION: {
      return {
        ...state,
        notifications: [
          ...state.notifications,
          { ...action.payload, closed: false, entered: false },
        ],
      };
    }
    case actionTypes.CLEAR_NOTIFICATIONS: {
      return {
        ...state,
        notifications: [],
      };
    }
    case actionTypes.MARK_AS_ENTERED: {
      const { current, all } = getSeparatedCurrentAndAllById(
        state.notifications,
        action.payload.id,
      );
      return {
        ...state,
        notifications: [...all, { ...current[0], entered: true }],
      };
    }
    case actionTypes.MARK_AS_CLOSED: {
      const { current, all } = getSeparatedCurrentAndAllById(
        state.notifications,
        action.payload.id,
      );
      return {
        ...state,
        notifications: [...all, { ...current[0], closed: true }],
      };
    }
    default:
      return state;
  }
};

export default reducer;
